var _circle, _circle2, _circle3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 370,
    height: 238,
    viewBox: "0 0 370 238",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 184.633,
    cy: 82.6324,
    r: 74.0531,
    transform: "rotate(-90 184.633 82.6324)",
    stroke: "#FFD200"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 185,
    cy: 83,
    r: 82.5,
    transform: "rotate(-90 185 83)",
    stroke: "#FFD200"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 185,
    cy: 83.0002,
    r: 50.6814,
    transform: "rotate(-90 185 83.0002)",
    fill: "#FFD200"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M184 71.0005H189V87.8005H184V71.0005ZM184 93.4005H189V99.0005H184V93.4005Z",
    fill: "#FFD200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.1f65a51da9e5835d6242a12e5a490fa6.svg";
export { ForwardRef as ReactComponent };